export default __webpack_public_path__ + "static/media/02.82f6e871.jpg";